import { useCallback, useEffect, useRef, useState } from "react";
import { useUser } from "contexts/userContext/userContext.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import SubscribersOnlyIcon from "components/Reusable/Form/Reusable/SubscribersOnlyIcon/SubscribersOnlyIcon";

interface IUseSubscribersOnlyOptionProps {
  callbackFunc: Function;
  subcribersOnly: boolean;
  disabled?: boolean;
  titleKey: string;
}

const useSubscribersOnlyOption = ({
  callbackFunc,
  subcribersOnly,
  disabled,
  titleKey,
}: IUseSubscribersOnlyOptionProps) => {
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const { isSubscribed, isLoggedIn } = useUser();

  const handleSetStatus = (status: boolean) => {
    if (!isSubscribed() && subcribersOnly) {
      setShowPromoPopup(true);
    } else {
      callbackFunc(status);
      setShowPromoPopup(false);
    }
  };

  useEffect(() => {
    if (isLoggedIn()) setShowPromoPopup(false);
  }, [isLoggedIn()]);

  const SubOnlyNotification = useCallback(() => {
    return subcribersOnly && !isSubscribed() ? (
      <SubscribersOnlyIcon
        {...{
          titleKey,
          showPromoPopup,
          setShowPromoPopup,
          disabled,
        }}
      />
    ) : null;
  }, [subcribersOnly, isSubscribed(), showPromoPopup]);

  return { handleSetStatus, SubOnlyNotification };
};

export default useSubscribersOnlyOption;
